<!--下单-->
<template>
  <div style="height:100%;background:#f8f8f8;padding-bottom:5rem">
    <!-- 下单 -->
    <div class="check-header">
      <div class="business-shop-info">
        <div class="business-shop-box">
          <div class="shop-name">
            <div style="font-size:19px">七彩星级考级报名</div>
            <!--<div class="shop-phone" style="font-size:14px">{{row.phone}}</div>-->
          </div>
        </div>
        <div class="shop-address">请确认考级信息，选择考级人员提交报名</div>
        <div class="delivery-times">
          <div class="timers-start">
            <van-icon name="clock-o"/>
            时间地点
          </div>
          <div class="timers-end">{{ row.province }}{{ row.city }}({{ row.datetitle }})</div>
        </div>
      </div>
    </div>

    <div style="height: 20px;"></div>

    <van-divider>考级信息</van-divider>

    <van-cell-group>
      <!--            <van-cell title="单位" :value="row.danwei" />-->
      <van-cell title="星级" :value="starType"/>
      <van-cell title="地址" :value="row.address"/>
      <van-cell title="联系电话" :value="row.phone"/>
    </van-cell-group>

    <van-divider v-if="!isSubmit">运动员信息</van-divider>

    <van-form
        v-if="!isSubmit"
        @submit="onSubmit"
        @failed="onFailed"
    >
      <van-cell-group>

        <van-field
            v-model="formData.name"
            :rules="[{ required: true, message: '姓名不能为空' }]"
            label="姓名"
            input-align="right"
            error-message-align="right"
            clearable
            placeholder="请填入报名人员姓名"
        />

        <van-field
            readonly
            clickable
            right-icon="arrow"
            input-align="right"
            @click="showNumTypePicker=true"
            label="证件类型"
            v-model="formData.numTypeName"
        />
        <div class="operate-desc-left">满14周岁以上不可参与考级</div>


        <van-popup v-model="showNumTypePicker" position="bottom">
          <van-picker :columns="numTypeColumns"
                      show-toolbar
                      :default-index="formData.numtype-1"
                      @cancel="showNumTypePicker = false"
                      @confirm="onNumTypeConfirm"
          />
        </van-popup>

        <van-field
            v-if="formData.numtype==1"
            v-model="formData.num"
            :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
            error-message-align="right"
            label="身份证"
            input-align="right"
            clearable
            placeholder="请输入身份证号"
        />

        <van-field
            v-else
            v-model="formData.num"
            :rules="[{ required: true, message: '护照号不能为空' }]"
            error-message-align="right"
            label="护照号"
            input-align="right"
            clearable
            placeholder="请输入护照号"
        />


      </van-cell-group>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中...">下一步
        </van-button>
      </div>
    </van-form>


    <van-divider v-if="isSubmit">运动员信息确认</van-divider>

    <van-form
        v-if="isSubmit"
        @submit="onConfirm"
    >
      <van-cell-group>

        <van-field
            v-model="formData.name"
            readonly
            label="姓名"
            input-align="right"
        />
        <div class="operate-desc-left">此处填写运动员姓名后将不予修改，须返回上一步重新认证运动员</div>


        <van-field
            v-model="formData.num"
            readonly
            label="证件号"
            input-align="right"
        />

        <van-field
            readonly
            clickable
            v-if="formData.numtype!=1"
            label="生日"
            input-align="right"
            error-message-align="right"
            placeholder="请选择生日"
            v-model="formData.birthday"
            :rules="[{ required: true, message: '请选择生日' }]"
            @click="showDate = true" />

        <van-popup v-model="showDate" position="bottom">

          <van-datetime-picker
              type="date"
              title="选择年月日"
              v-model="currentDate"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onDateConfirm"
              @cancel="showDate=false"
          />

        </van-popup>



        <van-cell title="护照照片" 
            v-if="formData.numtype!=1">
        </van-cell>

        <div class="row" 
            v-if="formData.numtype!=1">
          <PicUploader :fileList="formData.huzhao_pic" :limit="1"
                       :name="'pic'"></PicUploader>
        </div>
        <div class="operate-desc-left" 
            v-if="formData.numtype!=1">请上传护照（姓名和生日页）照片</div>


        <van-cell center title="是否连考">
          <template #right-icon>
            <van-switch  v-model="formData.is_exam_continue" @change="onLiankaoChange" active-color="#ffad19" :active-value="1" :inactive-value="2" size="24" />
          </template>
        </van-cell>
        <van-field
            name="radio" label="性别"
            input-align="right">
          <template #input>
            <van-radio-group v-model="formData.sex" direction="horizontal">
              <van-radio checked-color="#ffb01b" :name="1">男</van-radio>
              <van-radio checked-color="#ffb01b" :name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
            readonly
            clickable
            right-icon="arrow"
            @click="showGradePicker=true"
            v-model="formData.grade"
            error-message-align="right"
            label="报考星级"
            input-align="right"
        />
        <!-- <div class="operate-desc-left">黄星级及黄星级以上，须有近一年内CCA组织的赛事经历；</div> -->
        <div class="operate-desc-left">紫星级须有全国赛事经历；</div>
        <div class="operate-desc-left">连考须达到连考条件</div>

        <van-popup v-model="showGradePicker" position="bottom">
          <van-picker :columns="gradeSelectColumns"
                      show-toolbar
                      :default-index="formData.gradeindex-1"
                      @cancel="showGradePicker = false"
                      @confirm="onGradeConfirm"
          />
        </van-popup>


        <van-field
            name="project" label="项目类型"
            :rules="[{ required: true, message: '请选择项目类型' }]"
            v-if="formData.grade=='绿'||formData.grade=='青'||formData.grade=='蓝'||formData.grade=='紫'"
            input-align="right">
          <template #input>
            <van-radio-group v-model="formData.project" direction="horizontal">
              <van-radio checked-color="#ffb01b" name="花球">花球</van-radio>
              <van-radio checked-color="#ffb01b" name="街舞">街舞</van-radio>
              <van-radio checked-color="#ffb01b" name="爵士">爵士</van-radio>
              <van-radio checked-color="#ffb01b" name="技巧">技巧</van-radio>
            </van-radio-group>
          </template>
        </van-field>


        <van-field
            name="project" label="项目类型"
            :rules="[{ required: true, message: '请选择项目类型' }]"
            v-if="row.center.kaoji_jiameng_type==7"
            input-align="right">
          <template #input>
            <van-radio-group v-model="formData.project" direction="horizontal">
              <van-radio checked-color="#ffb01b" name="街舞">街舞</van-radio> 
            </van-radio-group>
          </template>
        </van-field>


        <van-field
            name="project" label="项目类型"
            :rules="[{ required: true, message: '请选择项目类型' }]"
            v-if="formData.grade=='绿'||formData.grade=='青'||formData.grade=='蓝'||formData.grade=='紫'"
            input-align="right">
          <template #input>
            <van-radio-group v-model="formData.project" direction="horizontal">
              <van-radio checked-color="#ffb01b" name="花球">花球</van-radio>
              <van-radio checked-color="#ffb01b" name="街舞">街舞</van-radio>
              <van-radio checked-color="#ffb01b" name="爵士">爵士</van-radio>
              <van-radio checked-color="#ffb01b" name="技巧">技巧</van-radio>
            </van-radio-group>
          </template>
        </van-field>


        <van-cell title="添加证件照片(2寸)">
        </van-cell>

        <div class="row">
          <PicUploader :fileList="formData.pic" :limit="1"
                       :name="'pic'"></PicUploader>
        </div>
        <div class="operate-desc-left">上传2寸免冠照,此照片用于证书粘贴打印</div>

        <van-cell title="品德文件（可选）">
        </van-cell>
        <div class="row">
          <FileUploader uploadText="上传文件" :fileList="formData.pindei_file" :limit="1" accept=".zip,.rar,.xls,.xlsx"
                        :name="'pindei_file'"></FileUploader>
        </div>
        <div class="operate-desc-left">图片+内容</div>

        <van-field
            v-model="formData.csize"
            error-message-align="right"
            v-if="formData.grade.indexOf('红') != -1"
            clearable
            left-icon="question-o"
            @click-left-icon="cSizeShow = true"
            :rules="[{ required: true, message: '请输入尺码' }]"
            label="衣服尺码"
            placeholder="请输入尺码"
            input-align="right"
        />
        <van-field
            v-model="formData.csize"
            error-message-align="right"
            v-else
            clearable
            left-icon="question-o"
            @click-left-icon="cSizeShow = true"
            label="衣服尺码"
            placeholder="请输入尺码"
            input-align="right"
        />
        <div @click="cSizeShow=true" class="operate-desc-left">查看衣服尺码表</div>
        <!---->
        <!--<van-field-->
        <!--v-model="formData.height"-->
        <!--error-message-align="right"-->
        <!--clearable-->
        <!--:rules="[{ required: true, message: '请输入身高' }]"-->
        <!--label="身  高"-->
        <!--placeholder="请输入身高(cm)"-->
        <!--input-align="right"-->
        <!--/>-->

        <!--<van-field-->
        <!--v-model="formData.weight"-->
        <!--error-message-align="right"-->
        <!--clearable-->
        <!--:rules="[{ required: true, message: '请输入体重' }]"-->
        <!--label="体  重"-->
        <!--placeholder="请输入体重(kg)"-->
        <!--input-align="right"-->
        <!--/>-->

        <van-field
            v-model="formData.footsize"
            clearable
            v-if="formData.grade.indexOf('红') != -1"
            :rules="[{ required: true, message: '请输入鞋码' }]"
            error-message-align="right"
            label="鞋  码"
            @click-left-icon="fSizeShow = true"
            placeholder="请输入鞋码"
            input-align="right"
        />
        <van-field
            v-model="formData.footsize"
            clearable
            v-else
            error-message-align="right"
            label="鞋  码"
            @click-left-icon="fSizeShow = true"
            placeholder="请输入鞋码"
            input-align="right"
        />
        <div @click="fSizeShow=true" class="operate-desc-left">查看鞋码表</div>

        <!--                <van-field-->
        <!--                        v-model="formData.famliy_name"-->
        <!--                        clearable-->
        <!--                        :rules="[{ required: true, message: '请输入家长姓名' }]"-->
        <!--                        error-message-align="right"-->
        <!--                        label="家长姓名"-->
        <!--                        placeholder="请输入家长姓名"-->
        <!--                        input-align="right"-->
        <!--                />-->

        <!--                <van-field-->
        <!--                        v-model="formData.famliy_num"-->
        <!--                        clearable-->
        <!--                        :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"-->
        <!--                        error-message-align="right"-->
        <!--                        label="身份证号码"-->
        <!--                        placeholder="请输入身份证号"-->
        <!--                        input-align="right"-->
        <!--                />-->


        <!--                <van-field-->
        <!--                        v-model="formData.phone"-->
        <!--                        clearable-->
        <!--                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"-->
        <!--                        error-message-align="right"-->
        <!--                        label="联系方式"-->
        <!--                        placeholder="请输入手机号"-->
        <!--                        input-align="right"-->
        <!--                />-->


      </van-cell-group>
      <div style="height: 1rem"></div>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中...">下一步
        </van-button>
      </div>
    </van-form>


    <van-dialog v-model="confirmShow" title="信息核对" show-cancel-button @confirm="onConfirmSubmit()">

      <van-cell-group style="height: 8rem ; overflow-y: scroll">

        <van-field
            v-model="formData.name"
            readonly
            label="姓名"
            input-align="right"
        />

        <van-field
            v-model="formData.num"
            readonly
            label="证件号"
            input-align="right"
        />


        <van-field
            v-model="formData.grade"
            readonly
            label="报考星级"
            input-align="right"
        />


        <van-cell title="证件照片(2寸)" v-if="formData.pic.length>0">
          <img :src="formData.pic[0].url" width="100"/>
        </van-cell>


        <!--<van-field-->
        <!--v-model="formData.height"-->
        <!--readonly-->
        <!--label="身  高"-->
        <!--input-align="right"-->
        <!--/>-->

        <!--<van-field-->
        <!--v-model="formData.weight"-->
        <!--readonly-->
        <!--label="体  重"-->
        <!--input-align="right"-->
        <!--/>-->

        <van-field
            v-model="formData.csize"
            readonly
            label="衣服尺码"
            input-align="right"
        />

        <van-field
            v-model="formData.footsize"
            readonly
            label="鞋  码"
            input-align="right"
        />

<!--        <van-field-->
<!--            v-model="formData.famliy_name"-->
<!--            readonly-->
<!--            label="家长姓名"-->
<!--            input-align="right"-->
<!--        />-->
<!--        <van-field-->
<!--            v-model="formData.famliy_num"-->
<!--            readonly-->
<!--            label="身份证号码"-->
<!--            input-align="right"-->
<!--        />-->
<!--        <van-field-->
<!--            v-model="formData.phone"-->
<!--            readonly-->
<!--            label="联系方式"-->
<!--            input-align="right"-->
<!--        />-->

      </van-cell-group>
    </van-dialog>


    <van-dialog v-model="cSizeShow" title="衣服尺码表">
      <img @click="picShow(key,cSizePicList)" v-for="(pic,key) in cSizePicList" :src="pic" style="width: 100%"/>
    </van-dialog>
    <van-dialog v-model="fSizeShow" title="鞋码表">
      <p style="padding: 10px; text-align: center">此鞋型偏小，建议选大一码</p>
      <img :src="fSizePicList[0]" @click="picShow(0,fSizePicList)" style="width: 100%"/>
    </van-dialog>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>


  </div>
</template>
<style scoped>

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.shop-name {
  display: flex;
  justify-content: space-between;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 27px;
  margin-top: 0.4rem;
  padding: 0 0.3rem;
}

.shop-address {
  height: 13px;
  font-size: 9px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 13px;
  margin-top: 0.1rem;
  padding: .2rem .3rem .4rem;
  border-bottom: 1px solid rgba(0, 0, 0, .1);
}

.delivery-times {
  margin-top: 0.2rem;
  padding: 0 0.3rem;
  display: flex;
  justify-content: space-between;
}

.business-shop-info {
  width: 6.81rem;
  height: 2.66rem;
  border-radius: 7px;
  margin-bottom: 0;
  display: flex;
  flex-flow: column;
  position: absolute;
  bottom: -0.4rem;
  left: 0;
  right: 0;
  margin: auto;
  background: #fff 6.5rem center;
  background-size: 10px;
}

.check-header {
  width: 100%;
  height: 4rem;
  background: url(../../../assets/images/bg-qcxj-index.png) no-repeat center;
  background-size: 100%;
  position: relative;
}

</style>

<script>
import {Field, Notify, Toast, Popup, Picker, Radio, RadioGroup, Dialog, ImagePreview} from "vant";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

export default {
  name: "ExameApplyMemberAdd",
  components: {
    [Field.name]: Field,
    Notify,
    Dialog,
    Radio,
    RadioGroup,
    Popup,
    PicUploader,
    [ImagePreview.Component.name]: ImagePreview.Component,
    Toast,
    Picker,
    LoginDialog,
    FileUploader
  },
  data: function () {
    return {
      validator,
      clockSecond:0,
      isSubmit: false,
      loginShow: false,
      cSizeShow: false,
      fSizeShow: false,
      confirmShow: false,
      showBirthday: false,
      showDate: false,
      kaoji_id: this.$route.query.kaoji_id,
      share_id: this.$route.query.share_id,
      gradeColumns: ['幼儿初', '幼儿中', '幼儿高', '红', '橙', '黄', '绿', '青', '蓝', '紫'],
      gradeSelectColumns: ['幼儿初', '幼儿中', '幼儿高', '红', '橙', '黄', '绿', '青', '蓝', '紫'],
      // 红橙、红橙黄、红橙黄绿、橙黄、橙黄绿、黄绿
      gradeLiankaoColumns:['幼儿初', '幼儿中', '幼儿高', '红', '橙', '黄', '绿', '青', '蓝', '紫'],
      // ['红','橙','黄','绿','青','蓝','紫','红橙','红橙黄','红橙黄绿','橙黄','橙黄绿','黄绿'],
      cSizePicList: ['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/7fd2e382afe6f9bd49b3ce9a8ae37a24.png', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/8fb609af0a199bea84da2ff641aacf1f.png'],
      fSizePicList: ['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/33e31ebf9997638013aacb02ed5eeb41.png'],
      showGradePicker: false,
      showNumTypePicker: false,
      message: "",
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      formData: {
        needLoadingIndicator: true,
        gradeindex: 0,
        grade: '',
        csize: '',
        numTypeName: '身份证',
        project:'',
        numtype: 1,
        birthday:'',
        sex:1,
        is_exam_continue: 2,
        kaoji_id: this.$route.query.kaoji_id,
        share_id: this.$route.query.share_id,
        name: '',
//                    num:'362323198807150036',
//                    pic:[{"uid":"vc-upload-1588058680174338","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-28/1588058680174338.png","name":" bg-doing.png","save_name":"h5/2020-04-28/1588058680174338.png"}],
        pic: [],
        huzhao_pic: [],
        pindei_file: []
//                    height:1,
//                    weight:2,
//                    footsize:3,
//                    famliy_name:'李',
//                    famliy_num:'320101197301011111',
//                    phone:'15177772222',
      },
      numTypeColumns: ['身份证', '护照'],
      row: {
        center:{}
      },
      warnings: [],
      starType: '',
      saveLoading: false,

    };
  },
  watch: {},

  filter: {},
  mounted() {
    document.title = "申报考级";
    this.fetch();
  },
  destroyed() {
  },
  methods: {
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.numtype = index + 1;
      this.showNumTypePicker = false;
    },

    onDateConfirm(date){
      console.log('onDateConfirm',date);
      this.showDate = false;
      this.formData.birthday =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },

    onLiankaoChange(value) {
      console.log(value)
      if(value == 1) {
        this.gradeSelectColumns = this.gradeLiankaoColumns
      } else {
        this.gradeSelectColumns = this.gradeColumns
      }
    },
    onGradeConfirm(value, index) {
      console.log('formData.grade', value)
      this.formData.grade = value;
      this.formData.gradeindex = index + 1;
      this.showGradePicker = false;
    },
    fetch() {
      let that = this;
      that.$api.get('/api/qcxj/kaojiJoinDetailNew', {
        kaoji_id: that.kaoji_id,
        share_id: that.share_id,
      }, (res) => {
        let starType = ''
        res.data.star_type.map(row => {
          starType = starType.concat(row.text + ' ')
        })

        console.log('star', starType)
        that.starType = starType;
        that.row = res.data;
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;

      that.$api.post('/api/qcxj/checkApplyNameNum', {
        name: that.formData.name,
        num: that.formData.num,
        numtype: that.formData.numtype,
      }, (res) => {
        if (res.data) {
          that.formData.height = res.data.height;
          that.formData.weight = res.data.weight;
          that.formData.footsize = res.data.footsize;
          that.formData.pic = res.data.pic;
          that.formData.famliy_name = res.data.famliy_name;
          that.formData.famliy_num = res.data.famliy_num;
          that.formData.phone = res.data.phone;
        }
        that.isSubmit = true;
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    picShow(index, list) {
      ImagePreview({
        images: list,
        startPosition: index,
      });
    },

    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onConfirm(values) {
      console.log('onSubmit-values', values);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {
        if(that.formData.pic.length==0){
            Toast.fail('请上传证件照');
            return
        }
        if(that.formData.numtype!=1  &&that.formData.huzhao_pic.length==0){
            Toast.fail('请上传护照照片');
            return
        }

        
        if (!that.formData.grade) {
          Toast.fail('请选择星级');
          return
        }
      }
      this.confirmShow = true;
    },
    onConfirmSubmit() {
      let that = this;
      that.saveLoading = true;
      that.$api.post('/api/qcxj/applyMemberAddSimple', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('报名成功');

        setTimeout(function () {
          rbLink({
            name: '',
            query: {}
          }, 'back')

        }, 500);

      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

            getCode() {
                let that = this;
                if (that.clockSecond > 0) {
                    return;
                }
                if (!that.formData.phone) {
                    Toast('请输入手机号')
                    return;
                }
                /*if (!that.formData.code) {
                    Toast('请输入验证码')
                    return;
                }*/
                that.$api.get('/api/index/phonecode', {phone: that.formData.phone}, (res) => {
                    Toast(res.msg);
                })

                that.clockSecond = 60;

                var t = setInterval(function () {
                    if (that.clockSecond > 0) {
                        that.clockSecond = that.clockSecond - 1;
                    } else {
                        clearInterval(t);
                    }
                }, 1000)
            }
  }
};
</script>



// WEBPACK FOOTER //
// ExameApplyMemberAdd.vue?0b424a3c